import { useSelector } from 'react-redux';
import { SessionType } from '@shared';
import { selectSession } from '@client/model/selectors';

// True when the current session is a wizard (internal) session. Gates
// engineering-internal affordances on the projection-details page.
export function useIsWizardSession(): boolean {
  const { sessionType } = useSelector(selectSession);
  return sessionType === SessionType.wizard;
}
